import { ModeEdit } from '@mui/icons-material';
import { IconButton, Stack } from '@mui/material';
import { ICellRendererParams } from 'ag-grid-community';

export interface EditActionCellParams {
  /** Called with the row's native record when the pencil is clicked. */
  onEditRow: (row: unknown) => void;
}

export function EditActionCell(params: ICellRendererParams & EditActionCellParams) {
  const { data, onEditRow } = params;
  if (!data) {
    return null;
  }
  return (
    <Stack direction='row' alignItems='center' height='100%'>
      <IconButton aria-label='edit' color='secondary' size='small' onClick={() => onEditRow(data)}>
        <ModeEdit />
      </IconButton>
    </Stack>
  );
}
